import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

export class ItemCategory{
    text:string;
    value:string;
    children:ItemCategory[];
}

@Component({
    selector: 'app-shopee-category',
    templateUrl: './shopee-category.component.html',
    styleUrls: ['./shopee-category.component.scss'],
    providers: [
        { provide: TreeviewI18n, useClass: SimpleDataTreeviewI18n }
    ],
    standalone: false
})
export class ShopeeCategoryComponent implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
  }

  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,public ThemeService:ThemeService, public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  onSelectedChange(evento){
  }

  onFilterChange(evento){

  }

  onClickLine(evento:TreeviewItem){
    if ( !evento.children ){
      this.dialogRef.close(evento.value);
    }
  }

  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {
  
    this.buttonList.push({
      color:"warn",
      description:"Sair",
      action: ()=>{
          this.okFunction();
      }
    })

    
    this.codecompany = (this.data as UntypedFormGroup).get("CODECOMPANY").value;
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }
    this.findCategories();
  }

  findCategories(){
    this.spinner.show();
    let ob = {
      "expressao": "getRequestData(GetCategory,Product,?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_category)&language=pt-br,GET,null,null,{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 47,
      "codecontract": 0,
      "values":[] 
    }
    
    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
        this.transformData(data);
    },error=>{
        this.spinner.hide();
        throw error;
    },()=>{
        this.spinner.hide();
    })
  
  }

  transformData(data):void{
    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children: []})];

    if ( data != null && ObjectUtil.isNotEmpty(data['resultado'])){
        
      let resultado:any = JSON.parse(data['resultado']);
      let array:[] = resultado?.response?.category_list || [];
    
      for ( var item of array.filter(i=>i['parent_category_id'] == 0 )){
        
        let category_id = item['category_id'];
        let parent_category_id = item['parent_category_id'];
        let display_category_name = item['display_category_name'];
        let has_children = item['has_children'];
        let dataItem:TreeviewItem = new TreeviewItem({text:display_category_name, value:category_id,collapsed:true, checked:false });
        
        if ( this.lista[0].children == null ){
          this.lista[0].children = [dataItem];
        }else{
          this.lista[0].children.push(dataItem);      
        }
        
        
        if ( has_children){
          this.findItem(array,category_id,dataItem);
        }
        
      }
    }
    
  }

  findItem(array:Object[],  category_id:string, lista:TreeviewItem):void{

      let newArray:Object[] = array.filter(data=> data['parent_category_id'] == category_id );
  
      for ( var item of newArray ){
          let has_children = item['has_children'];
          let new_category_id = item['category_id'];
          let parent_category_id = item['parent_category_id'];
          let display_category_name = item['display_category_name'];
          let dataItem:TreeviewItem = new TreeviewItem({text:new_category_id + ' - '+ display_category_name, value:new_category_id, collapsed:true, checked: false, children:[] });
          if ( lista.children == null ){
            lista.children = [ dataItem ];
          }else{
            lista.children.push(dataItem)
          }
          
          
          if ( has_children){
            this.findItem(array,new_category_id,dataItem);
          }
      }  
  }
  
  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
  }

}
